export default {"src":"/_next/static/media/nmr.2b7ee313.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};